module.exports = __webpack_public_path__ + "static/media/financeHead.a6796bf3.jpg";